"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomerTemplateContentType = void 0;
var CustomerTemplateContentType;
(function (CustomerTemplateContentType) {
    CustomerTemplateContentType["TOURNAMENTS"] = "tournaments";
    CustomerTemplateContentType["ASSESSMENT"] = "assessments";
    CustomerTemplateContentType["COURSES"] = "courses";
    CustomerTemplateContentType["LESSONS"] = "lessons";
    CustomerTemplateContentType["LEADERBOARD"] = "leaderboards";
    CustomerTemplateContentType["CHALLENGE"] = "challenges";
})(CustomerTemplateContentType = exports.CustomerTemplateContentType || (exports.CustomerTemplateContentType = {}));
